var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-item',{staticClass:"datetime",attrs:{"label":_vm.data.fieldname}},[_c('div',{directives:[{name:"decorator",rawName:"v-decorator",value:([("" + (_vm.data.fieldkey)), {
      rules: [{
        required: _vm.data.isneeded === 1,
        message: _vm.placeholder
      }],
      initialValue: _vm.defaultValue
    }]),expression:"[`${data.fieldkey}`, {\n      rules: [{\n        required: data.isneeded === 1,\n        message: placeholder\n      }],\n      initialValue: defaultValue\n    }]"}]},[_c('a-date-picker',{attrs:{"value":_vm.defaultValue,"placeholder":_vm.placeholder,"show-time":_vm.showTime,"format":_vm.dateFormat,"dropdown-class-name":"my-data-picker","get-calendar-container":function (triggerNode) {
          return triggerNode.parentNode || _vm.document.body;
        },"disabled":_vm.data.disabled},on:{"change":_vm.onChange,"ok":_vm.onOk}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }